


















































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'

// Components
import BeaconCamera from '../../shared/BeaconCamera.vue'

@Component({
  components: {
    BeaconCamera,
  },
})
export default class BeaconUpsertForm extends Vue {
  @Prop()
  parent!: any

  specialBeaconTypes = ['', 'mitsuiwa_beacon']

  async handleApplyChange(): Promise<void> {
    this.$validator.validateAll().then((result) => {
      if (!result) {
        return false
      }
      if (this.$refs.beaconRef && !(this.$refs as any).beaconRef.submit()) {
        return false
      }
      this.parent.handleApplyChange()
    })
  }

  onSelectType(data) {
    if (!data) {
      this.parent.selected.san_id = ''
    }
  }
}
